export enum EAuthorization_Permissions {
    'manage-account' = 'manage-account',
    'manage-account-links' = 'manage-account-links',
    'view-profile' = 'view-profile',
}

export enum EAuthorization_Features {
    ClearingUser = 'ClearingUser',
    RIA = 'RIA',
    Client = 'Client',
    Admin = 'Admin',
    SuperAdmin = 'SuperAdmin',
    TradeDesk = 'TradeDesk',
}
